import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../../Model/Combo/combo.service';
import { SessionService } from '../../../Util/Session/session.service';

@Component({
  selector: 'app-letter-template-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgSelectModule],
  templateUrl: './letter-template-form.component.html',
  styleUrl: './letter-template-form.component.scss'
})
export class LetterTemplateFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  LetterTemplateDetail = {
    SelectType: 'I',
    ESS_LetterTemplateMasterID: 0,
    LetterCode: null as any,
    LetterName: null,
    ESS_LetterDocumentTypeMasterID: null,
    Active: true,
  }

  LetterTypes = [] as any;
  user = [] as any;

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private letterDocument: LetterDocumentService,
    private combo: ComboService,
    private session: SessionService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.LetterTemplateDetail.ESS_LetterTemplateMasterID = this.ID;
    this.ESSLetterDocumentTypeMasterSelect();
    if (this.ID > 0) {
      this.ESSLetterTemplateMasterSelect();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESSLetterDocumentTypeMasterInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  ESSLetterTemplateMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterTemplateMasterSelect({ ESS_LetterTemplateMasterID: this.LetterTemplateDetail.ESS_LetterTemplateMasterID, SelectType: 1 }).subscribe({
      next: (response) => {
        this.LetterTemplateDetail = response.Table[0];
        this.LetterTemplateDetail.SelectType = 'U';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESSLetterDocumentTypeMasterInsertUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if ((this.LetterTemplateDetail.ESS_LetterTemplateMasterID == 0 && this.common.PageRight.IsAdd) || (this.LetterTemplateDetail.ESS_LetterTemplateMasterID > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.LetterTemplateDetail.LetterCode = this.common.ToUpperCase(this.LetterTemplateDetail.LetterCode);
          this.letterDocument.ESSLetterTemplateMasterInsertUpdate(this.LetterTemplateDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '535' || response.Error_Code == '536') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close(true);
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  ESSLetterDocumentTypeMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterDocumentTypeMasterSelect({ ESS_LetterDocumentTypeMasterID: 0, SelectType: 2 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.LetterTypes = response.Table;
        } else {
          this.LetterTypes = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.activeModal.close();
  }
}
